import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import {useCompanies} from "../../Hooks/useCompanies";

const Companies = (props) => {
    const [companiesData, addCompany, updateCompany, deleteCompany] = useCompanies();

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Nombre", field: "name", defaultSort: 'asc' },
        { title: "Dirección", field: "address" },
        { title: "Email", field: "email" },
        { title: "Teléfono", field: "telephone" },
        { title: "Contacto", field: "contact" }
    ];

    return <MainTable 
            title="Empresas"
            columns={columns}
            data={companiesData}
            requiredFields={["name", "address", "email", "telephone", "contact"]}
            deleteText="Se borraran todos los usuarios, acuerdos, arrendamientos y requerimientos asociados"
            onRowAdd={addCompany}
            onRowUpdate={updateCompany}
            onRowDelete={deleteCompany}
            />
}

export default Companies


// WEBPACK FOOTER //
// ./src/Containers/Companies/Companies.js